import React from 'react';
import { BRAND_NAME } from '../config/brand';

interface DrupiLogoProps {
  fill?: string;
  height?: number;
}

export const DrupiLogo: React.FC<DrupiLogoProps> = ({ fill = 'currentColor', height = 24 }) => (
  <span
    style={{
      display: 'block',
      color: fill,
      fontSize: height,
      fontWeight: 800,
      lineHeight: 1,
      letterSpacing: '-0.02em',
    }}
  >
    {BRAND_NAME}
  </span>
);
